import styled, { css } from 'styled-components'
// components
import { SubHeader } from 'components/Modals/PlanItems/styles'
// constants
import { APP_BAR_HEIGHT } from 'constants/index'
// themes
import colors from 'themes/colors'

export const PLAN_SIDEBAR_INFO_WIDTH = 416

export const Wrapper = styled('div')<{ $isReview: boolean; $collapsed?: boolean }>`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  height: calc(100vh - ${APP_BAR_HEIGHT}px);
  max-height: calc(100vh - ${APP_BAR_HEIGHT}px);
  position: fixed;
  width: ${PLAN_SIDEBAR_INFO_WIDTH}px;
  transition: width 0.2s ease;

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      border-right: none;
      width: 32px;

      > * {
        visibility: hidden;
      }

      ${SubHeader} {
        visibility: visible;

        > div:first-child {
          visibility: hidden;
        }
      }
    `}

  ${({ $isReview }) =>
    $isReview &&
    css`
      border: none;
      top: 64px;
      width: 600px;
    `}
`

export const CollapseToggle = styled('div')<{ $collapsed?: boolean }>`
  position: absolute;
  right: -8px;
  top: 6px;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.purple400};
  transition: left 0.2s ease;
  background: ${colors.blue500};
  box-shadow:
    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;

  svg {
    font-size: 22px;
    ${({ $collapsed }) => ($collapsed ? 'transform: rotate(0deg);' : 'transform: rotate(180deg);')};

    path {
      fill: white;
    }
  }
`
